import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dashboarditem',
  standalone: true,
  imports:[FormsModule,CommonModule],
  templateUrl: './dashboarditem.component.html',
  styleUrls: ['./dashboarditem.component.scss']
})
export class DashboarditemComponent implements OnInit {
  @Input() title: string = "No Title";
  @Input() cssClass: string = "";

  constructor() { }

  ngOnInit(): void {
  }

}
